import { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Grid,
  CurrencyInput,
  MaskedInput,
} from "../../../../../components";
import { value, InputErros } from "../../../../../helpers";
import { pedagioValidator } from "../../middlewares";
import shortid from "shortid";
import { unformatPrice } from "../../../../../utils";

const PedagioDialog = ({
  open,
  setOpen,
  setPedagios,
  pedagios,
  id,
  cadastrarPedagio,
}) => {
  const [pedagio, setPedagio] = useState({});
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const onSubmit = (event) => {
    event.preventDefault();
    validarPedagio();
  };

  function validarPedagio() {
    pedagioValidator
      .validate(pedagio, { abortEarly: false })
      .then(async () => {
        adicionarPedagio();
      })
      .catch(async (err) => {
        inputErros.set(err);
      });
  }

  function adicionarPedagio() {
    const pedagioAdicao = {
      id: shortid.generate(),
      fatMdfeId: id,
      ...pedagio,
    };
    if (id) {
      cadastrarPedagio(pedagioAdicao);
    } else {
      setPedagios([...pedagios, pedagioAdicao]);
    }
    setPedagio({});
    inputErros.limpar();
    setOpen(false);
  }

  const handleInputBlur = (event) => {
    const valor = parseFloat(unformatPrice(event.target.value));
    setPedagio({
      ...pedagio,
      [event.target.name]: valor || null,
    });
  };

  const handleChangeInput = (event) => {
    setPedagio({
      ...pedagio,
      [event.target.name]: event.target.value ? event.target.value : undefined,
    });
  };

  return (
    <Dialog disableEscapeKeyDown maxWidth="sm" fullWidth open={open}>
      <form onSubmit={(event) => onSubmit(event)}>
        <DialogContent>
          <CardHeader title="Cadastrar Pedagio" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <MaskedInput
                  id="cnpjFornecedora"
                  label="CNPJ Fornecedora"
                  name="cnpjFornecedora"
                  variant="outlined"
                  margin="none"
                  mask="**.***.***/****-99"
                  onChange={(event) => handleChangeInput(event)}
                  value={value.text(pedagio?.cnpjFornecedora)}
                  error={inputErros.get("cnpjFornecedora")}
                />
              </Grid>
              <Grid item xs={6}>
                <MaskedInput
                  id="cnpjPagador"
                  label="CNPJ Pagador"
                  name="cnpjPagador"
                  variant="outlined"
                  margin="none"
                  mask="**.***.***/****-99"
                  onChange={(event) => handleChangeInput(event)}
                  value={value.text(pedagio?.cnpjPagador)}
                  error={inputErros.get("cnpjPagador")}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="comprovante"
                  name="comprovante"
                  label="Comprovante Pedagio"
                  error={inputErros.get("comprovante")}
                  type="text"
                  value={value.text(pedagio?.comprovante)}
                  onChange={(event) => handleChangeInput(event)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <CurrencyInput
                  id="valor"
                  name="valor"
                  label="Valor Pedagio"
                  margin="none"
                  error={inputErros.get("valor")}
                  value={value.text(pedagio?.valor)}
                  onBlur={handleInputBlur}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button variant="contained" color="primary" type="submit">
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              SALVAR
            </Button>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => setOpen(false)}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default PedagioDialog;
